import { useQuery } from '@apollo/client';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import React, { useContext, useRef } from 'react';

import pkg from '../../../package.json';
import Badge from '../../components/bootstrap/Badge';
import Tooltips from '../../components/bootstrap/Tooltips';
import ThemeContext from '../../contexts/themeContext';
import useAsideTouch from '../../hooks/useAsideTouch';
import { GET_WEBSITES } from '../../queries/websites';
import Brand from '../Brand/Brand';
import Navigation from '../Navigation/Navigation';
import User from '../User/User';

const Aside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const { asideStyle, touchStatus, hasTouchButton, asideWidthWithSpace, x } = useAsideTouch();

	const isModernDesign = process.env.REACT_APP_MODERN_DESGIN === 'true';

	const constraintsRef = useRef(null);

  const { data } = useQuery(GET_WEBSITES);
  const websites = data?.websites;

	return (
		<>
			<motion.aside
				style={asideStyle}
				className={classNames(
					'aside',
					{ open: asideStatus },
					{
						'aside-touch-bar': hasTouchButton && isModernDesign,
						'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
						'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
					},
				)}>
				<div className='aside-head'>
					<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
				</div>
        <User />
				<div className='aside-body'>
          { websites &&
            <Navigation
              menu={ websites.map( website =>
                ({
                  id: website.id,
                  text: website.name || website.title || website.domain.value,
                  icon: website.logo ? null : 'Dashboard',
                  image: website.logo,
                  path: `/website/${website.id}`,
                })
              ) }
              id='aside-websites'
            />
          }
				</div>
        <div className="aside-foot">
          <nav aria-label="aside-bottom-menu">
            <div className="navigation" style={{ padding: 10, }}>
              <Badge>v{pkg.version}</Badge>
            </div>
          </nav>
        </div>
			</motion.aside>
			{asideStatus && hasTouchButton && isModernDesign && (
				<>
					<motion.div className='aside-drag-area' ref={constraintsRef} />
					<Tooltips title='Toggle Sidebar' flip={['top', 'right']}>
						<motion.div
							className='aside-touch'
							drag='x'
							whileDrag={{ scale: 1.2 }}
							whileHover={{ scale: 1.1 }}
							dragConstraints={constraintsRef}
							// onDrag={(event, info) => console.log(info.point.x, info.point.y)}
							dragElastic={0.1}
							style={{ x, zIndex: 1039 }}
							onClick={() => x.set(x.get() === 0 ? asideWidthWithSpace : 0)}
						/>
					</Tooltips>
				</>
			)}
		</>
	);
};

export default Aside;
